<template>
  <svg width="28"
       height="21"
       viewBox="0 0 28 21"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.3332 4.33332H15.3332V6.99999H27.3332V4.33332ZM27.3332 15H15.3332V17.6667H27.3332V15ZM5.3865 9.66666L0.666504 4.94666L2.5465 3.06666L5.37317 5.89332L11.0265 0.23999L12.9065 2.11999L5.3865 9.66666ZM5.3865 20.3333L0.666504 15.6133L2.5465 13.7333L5.37317 16.56L11.0265 10.9067L12.9065 12.7867L5.3865 20.3333Z"
      fill="url(#paint0_linear_155_2302)" />
    <path
      d="M27.3332 4.33332H15.3332V6.99999H27.3332V4.33332ZM27.3332 15H15.3332V17.6667H27.3332V15ZM5.3865 9.66666L0.666504 4.94666L2.5465 3.06666L5.37317 5.89332L11.0265 0.23999L12.9065 2.11999L5.3865 9.66666ZM5.3865 20.3333L0.666504 15.6133L2.5465 13.7333L5.37317 16.56L11.0265 10.9067L12.9065 12.7867L5.3865 20.3333Z"
      fill="url(#paint0_linear_155_2302)"
      fill-opacity="0.2" />

    <defs>
      <linearGradient id="paint0_linear_155_2302"
                      x1="13.3333"
                      y1="0"
                      x2="13.3333"
                      y2="26.6667"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#59BEE5'}` : color" />
        <stop offset="1" :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#118EBE'}` : color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>
